<script lang="ts">
	import { consent, init as initTrackingStore, type ApiKeys } from '$lib/stores/trackingStore';
	import { onMount } from 'svelte';
	import GoogleAnalytics from './GoogleAnalytics.svelte';
	import GoogleTagmanager from './GoogleTagmanager.svelte';
	import MetaPixel from './MetaPixel.svelte';
	export let keys: ApiKeys;

	onMount(() => {
		initTrackingStore(keys);
	});
</script>

{#if $consent?.['marketing']}
	{#if keys.googleTagmanagerId}
		<GoogleTagmanager id={keys.googleTagmanagerId} />
	{/if}
	{#if keys.facebookPixelId}
		<MetaPixel id={keys.facebookPixelId} />
	{/if}
{/if}

{#if keys.googleAnalyticsId}
	<GoogleAnalytics id={keys.googleAnalyticsId} />
{/if}
